import { render, staticRenderFns } from "./page-sidebar.component.vue?vue&type=template&id=5182e4dc&"
import script from "./page-sidebar.component.vue?vue&type=script&lang=ts&"
export * from "./page-sidebar.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports